import { useEffect } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { Link } from 'react-router-dom';

import styles from './styles';
import Box from '@material-ui/core/Box';

import { Location } from '@cobliteam/common-types';

import {
  Heading1,
  NoConnectionIcon,
  PlaceholderText,
} from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

import type { Refresh } from '@material-ui/icons';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

type ErrorPageProps = {
  path?: string;
} & FallbackProps;

const ErrorPage = ({ error, path, resetErrorBoundary }: ErrorPageProps) => {
  useEffect(() => {
    return () => {
      resetErrorBoundary();
    };
  }, [resetErrorBoundary, path]);

  return (
    <div className={styles.errorPage}>
      <NoConnectionIcon />
      <Heading1>Algum error inesperado aconteceu.</Heading1>
      <PlaceholderText>
        Estamos trabalhando para que este erro seja corrigido o mais rápido
        possível.
      </PlaceholderText>
      <Box justifyContent='center' mt={2}>
        Error: {error.message}
      </Box>
      <Link to={Location.HOME}>
        <Button
          variant='text'
          startIcon={<RefreshRoundedIcon />}
          onClick={() => window.location.reload()}
        >
          Tentar novamente
        </Button>
      </Link>
    </div>
  );
};

export default ErrorPage;
